import Data from "~/util/data";

export class User extends Data {
    constructor(
        public readonly id: string,
        public name: string,
        public email: string,
        public avatar: string | null | undefined = undefined,
        public phone: string | null | undefined = undefined,
        public profile_id: string | null | undefined = undefined,
    ) {
        super();
    }
}
